<template>
  <div>
    <!-- Header Card with Return Button -->
    <a-card class="header-card" :bordered="false">
      <div class="header-content">
        <a-button
          type="primary"
          icon="arrow-left"
          @click="goBack"
          class="return-btn"
        >
          {{ $t("action.retour") }}
        </a-button>
        <h2 class="page-title">{{ $t("liste.nouveauPaiement") }}</h2>
      </div>
    </a-card>

    <!-- Main Content Card -->
    <a-card class="main-card" :bordered="false">
      <InvoiceBuilder @reload="handleReload" :key="reloads" />
    </a-card>
  </div>
</template>

<script>
import InvoiceBuilder from "../profile/components/invoiceBuilder/index.vue";

export default {
  name: "NewPayment",

  components: {
    InvoiceBuilder,
  },
  data() {
    return {
      reloads: 0,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    handleReload() {
      this.reloads = this.reloads + 1;
    },
  },
};
</script>

<style scoped>
.header-card {
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.return-btn {
  border-radius: 6px;
  height: 40px;
  padding: 0 16px;
  font-weight: 500;
}

.page-title {
  margin: 0;
  color: #262626;
  font-size: 20px;
  font-weight: 600;
}

.main-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

/* Responsive design */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .page-title {
    font-size: 18px;
  }
}
</style>
